import type { CoreError, CoreErrorApi } from '@ingenico/api-sdk-core/common';
import type { ErrorWithPlaceholdersApi } from '@ingenico/api-sdk-device-management-private-v2';

export function convertPlaceholdersToObject(
  placeholders: ErrorWithPlaceholdersApi['placeholders'],
): Record<string, string> {
  const response: Record<string, string> = {};

  placeholders?.forEach(({ key, value }) => {
    response[key] = value;
  });

  return response;
}

function isErrorWithPlaceholdersApi(
  error: CoreErrorApi | ErrorWithPlaceholdersApi | undefined,
): error is ErrorWithPlaceholdersApi {
  return (error as ErrorWithPlaceholdersApi)?.placeholders !== undefined;
}

export interface ErrorWithPlaceholdersApiInData extends Omit<CoreError, 'data'> {
  readonly data?: CoreErrorApi | ErrorWithPlaceholdersApi;
}

export function convertPlaceholdersIfErrorHasPlaceholders(
  error: CoreErrorApi | ErrorWithPlaceholdersApi | undefined,
): Record<string, string> {
  return isErrorWithPlaceholdersApi(error) ? convertPlaceholdersToObject(error.placeholders) : {};
}
